import { IonAlert, IonButton, IonCol, IonIcon, IonRow } from "@ionic/react";
import "./Breadcrumb.css";
import { arrowBackOutline } from "ionicons/icons";
import { useState } from "react";
import { useHistory } from "react-router";

interface BreadcrumbProps {
  backUrl: string;
  activeElement: number;
  trailer: boolean;
  backConfirmation?: boolean;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  backUrl,
  activeElement,
  trailer,
  backConfirmation = false,
}) => {
  const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
  let history = useHistory();

  return (
    <div className="Breadcrumb-container">
      <IonAlert
        isOpen={confirmModalIsOpen}
        header="Êtes vous sur ?"
        message="Vous allez quitter l'inspection de votre véhicule, êtes vous sûr ?"
        className="Breadcrumb-alert"
        buttons={[
          {
            text: "Annuler",
            role: "cancel",

            handler: () => {
              setConfirmModalIsOpen(false);
            },
          },
          {
            text: "OK",
            role: "confirm",
            handler: () => {
              history.push(backUrl);
            },
          },
        ]}
        onDidDismiss={() => setConfirmModalIsOpen(false)}
      ></IonAlert>
      {backConfirmation ? (
        <IonButton
          shape="round"
          className="Breadcrumb-backButton"
          onClick={() => setConfirmModalIsOpen(true)}
        >
          <IonIcon slot="icon-only" icon={arrowBackOutline} />
        </IonButton>
      ) : (
        <IonButton
          shape="round"
          className="Breadcrumb-backButton"
          routerLink={backUrl}
          routerDirection="back"
        >
          <IonIcon slot="icon-only" icon={arrowBackOutline} />
        </IonButton>
      )}
      <div className="Breadcrumb-row ">
        <div
          className={`Breadcrumb-item ${
            activeElement >= 0 ? "Breadcrumb-item_active" : ""
          }`}
        ></div>
        <IonRow className="Breadcrumb-row Breadcrumb-row_small">
          <div
            className={`Breadcrumb-item Breadcrumb-item_small ${
              activeElement >= 1.1 ? "Breadcrumb-item_active" : ""
            }`}
          ></div>
          <div
            className={`Breadcrumb-item Breadcrumb-item_small ${
              activeElement >= 1.2 ? "Breadcrumb-item_active" : ""
            }`}
          ></div>
          <div
            className={`Breadcrumb-item Breadcrumb-item_small ${
              activeElement >= 1.3 ? "Breadcrumb-item_active" : ""
            }`}
          ></div>
          <div
            className={`Breadcrumb-item Breadcrumb-item_small ${
              activeElement >= 1.4 ? "Breadcrumb-item_active" : ""
            }`}
          ></div>
          <div
            className={`Breadcrumb-item Breadcrumb-item_small ${
              activeElement >= 1.5 ? "Breadcrumb-item_active" : ""
            }`}
          ></div>
          <div
            className={`Breadcrumb-item Breadcrumb-item_small ${
              activeElement >= 1.6 ? "Breadcrumb-item_active" : ""
            }`}
          ></div>
          <div
            className={`Breadcrumb-item Breadcrumb-item_small ${
              activeElement >= 1.7 ? "Breadcrumb-item_active" : ""
            }`}
          ></div>
        </IonRow>
        {trailer ? (
          <div
            className={`Breadcrumb-item ${
              activeElement >= 2 ? "Breadcrumb-item_active" : ""
            }`}
          ></div>
        ) : null}
        {trailer ? (
          <IonRow className="Breadcrumb-row Breadcrumb-row_small">
            <div
              className={`Breadcrumb-item Breadcrumb-item_small ${
                activeElement >= 3.1 ? "Breadcrumb-item_active" : ""
              }`}
            ></div>
            <div
              className={`Breadcrumb-item Breadcrumb-item_small ${
                activeElement >= 3.2 ? "Breadcrumb-item_active" : ""
              }`}
            ></div>
            <div
              className={`Breadcrumb-item Breadcrumb-item_small ${
                activeElement >= 3.3 ? "Breadcrumb-item_active" : ""
              }`}
            ></div>
            <div
              className={`Breadcrumb-item Breadcrumb-item_small ${
                activeElement >= 3.4 ? "Breadcrumb-item_active" : ""
              }`}
            ></div>
            <div
              className={`Breadcrumb-item Breadcrumb-item_small ${
                activeElement >= 3.5 ? "Breadcrumb-item_active" : ""
              }`}
            ></div>
            <div
              className={`Breadcrumb-item Breadcrumb-item_small ${
                activeElement >= 3.6 ? "Breadcrumb-item_active" : ""
              }`}
            ></div>
          </IonRow>
        ) : null}
      </div>
    </div>
  );
};

export default Breadcrumb;
